export default {
  nome: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  url: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  icon: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/links/components/add/link-form.js